import { usePrettyLogEventPage } from "@components/v2/analytics";
import { useMetricsExplorerContext } from "@features/metrics-explorer/hooks";
import { Switch } from "@shared/switch";

export const ChartControls = () => {
  const prettyLogEventPage = usePrettyLogEventPage();

  const {
    metricsData,
    chartState: { alignAxesScale },
    setAlignAxesScale,
  } = useMetricsExplorerContext();

  return (
    <div className="__hide-on-pdf-export flex items-center justify-end gap-2">
      <Switch
        id="align-axis"
        size="medium"
        disabled={metricsData.length === 0}
        onChange={(val) => {
          prettyLogEventPage({
            domain: "Metrics Explorer",
            action: "onChange",
            additionalActionInfo: "Change align axes scale",
            data: {
              newAlignAxesScale: val,
              pageContext: { alignAxesScale },
            },
          });

          setAlignAxesScale(val);
        }}
        value={alignAxesScale}
      />
      <div className="text-sm text-v2-secondary">Align axes</div>
    </div>
  );
};
